import React, { Component } from "react";
import PDFVisitsReportDocument from "./PDFVisitsReportDocument";
import MainLayout from "../../Components/Layouts/MainLayout";
import UsersDataService from "../../Components/Services/Users.Service";
import Toastr from "../../Utils/Toastr";
import cookie from 'react-cookies';
import { Redirect } from "react-router-dom";
import Select from 'react-select';

const signedList = [
  { value: 0, label: 'All' },
  { value: 1, label: 'Signed In Only' },
  { value: 2, label: 'Signed Out Only' }
];

export default class ReportsPageVisitor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      modalOpen: false,
      pdfDocOpen: false,
      staffOptions: [],
      reportHeading: "",
      startDate: "",
      endDate: "",
      list: [],
      pdfContent: [],
      docTitle: 'PZ Visitors Report',
      voucherTypesOptions: [],
      selectedVoucherType: 0,
      selectedPurposeId: -1,
      selectedOptions: [],
    }
    this.callUpdateCheckBox = this.callUpdateCheckBox.bind(this);
  };

  componentWillMount() {
    if (localStorage.getItem('unitid') != 10 && localStorage.getItem('unitid') != 40) {
      alert("Access Denid!!!\nOnly Reports and Admin Units are allowed access to Reports menu");
      this.setState({ redirectUrl: "/user/dashboard" });
    }
  }

  componentDidMount() {
    this.getStaffs();
    this.setState({ startDate: (cookie.load('startDate') != undefined) ? cookie.load('startDate') : "" })
    this.setState({ endDate: (cookie.load('endDate') != undefined) ? cookie.load('endDate') : "" })
  }

  getStaffs = async () => {
    await UsersDataService.getStaffs()
      .then(res => {
        const data = res.data;
        // console.log("getStaffs data::: "+JSON.stringify(data))
        data.sort((a, b) => a.id - b.id);
        const options = data.map(d => ({
          "value": d.id,
          "label": d.firstName + " " + d.lastName
        }))
        this.setState({ staffOptions: options });
      })
      .catch(e => {
        this.setState({ loading: false });
      });
  };

  handleChange = (selectedOptions) => {
    this.setState({ selectedOptions });
  };

  handlePurposeChange = (e) => {
    this.setState({ selectedPurposeId: e.value });
  }

  callUpdateCheckBox = (e, id, voucherName) => {
    let isChecked = e.target.checked;
    let items = this.state.list;
    items.map(item => {
      if (id == item.id) {
        item.status = (isChecked) ? true : false;
      }
    })
  }

  getVoucherTypes = async () => {
    await UsersDataService.getVoucherTypes()
      .then(res => {
        const data = res.data;
        this.setState({ list: data });
      })
      .catch(e => {
        this.setState({ loading: false });
      });
  };

  viewPDFReport = async () => {
    this.setState({ loading: true });
    let errormessage = "";
    if (this.refs.startDate.value == "") {
      errormessage = <div>{errormessage}<div>Start Date can not be blank<br /></div></div>;
    }
    if (this.refs.endDate.value == "") {
      errormessage = <div>{errormessage}<div>End Date can not be blank<br /></div></div>;
    }
    
    if (errormessage != "") {
      errormessage = <div><h5>Please correct the following errors:</h5>{errormessage}</div>;
      Toastr("error", errormessage);
      return true;
    }
    let items = this.state.selectedOptions;
    let val = '';

    items.map(item => {
      val += (val == '') ? item.value : ', '+item.value;
    });

    var data = {
      startDate: this.refs.startDate.value,
      endDate: this.refs.endDate.value,
      staffIds: val,
      approvalStatus: this.state.selectedPurposeId,
    };
console.log("viewPDFReport data::: "+JSON.stringify(data))
    await UsersDataService.getVisitsByDate(data)
      .then(res => {
        const list = res.data;
console.log("res.data::: "+JSON.stringify(list))
        this.setState({ pdfContent: list });
        this.setState({ pdfDocOpen: true });
      })
      .catch(e => {
        this.setState({ loading: false });
      });
  }

  render() {
    const { selectedOptions } = this.state;

    return this.state.redirectUrl ? (
      <Redirect to={this.state.redirectUrl} />
    ) : (
      <MainLayout
        role="user"
        title="Visitors Report"
      >
        <div className="card card-bordered" style={{ width: "50%" }}>
          <div className="card-inner-group">
            <div className="card-inner p-0">
              <div className="nk-tb-list">
                <div className="nk-tb-item">
                  <div className="nk-tb-col tb-col-md" style={{ width: "20%" }}>
                    <label className="form-label">Start Date:</label>
                  </div>
                  <div className="nk-tb-col tb-col-md" style={{ width: "30%" }}>
                    <input
                      type="date"
                      id="startDate"
                      name="startDate"
                      ref="startDate"
                      className="form-control"
                      defaultValue={this.state.startDate}
                      required
                    />
                  </div>
                </div>
                <div className="nk-tb-item">
                  <div className="nk-tb-col tb-col-md">
                    <label className="form-label">End Date:</label>
                  </div>
                  <div className="nk-tb-col tb-col-md">
                    <input
                      type="date"
                      id="endDate"
                      name="endDate"
                      ref="endDate"
                      className="form-control"
                      defaultValue={this.state.endDate}
                      required
                    />
                  </div>
                </div>
                <div className="nk-tb-item">
                  <div className="nk-tb-col tb-col-md">
                    <label className="form-label">Staff Visited:</label>
                  </div>
                  <div className="nk-tb-col tb-col-md">
                    <Select
                      isMulti
                      value={selectedOptions}
                      onChange={this.handleChange}
                      options={this.state.staffOptions}
                    />
                  </div>
                </div>
                <div className="nk-tb-item">
                  <div className="nk-tb-col tb-col-md">
                    <label className="form-label">Sign In/Sign Out Option</label>
                  </div>
                  <div className="nk-tb-col tb-col-md">
                  <Select
                        id="purposeIdEdit"
                        name="purposeIdEdit"
                        ref="purposeIdEdit"
                        className="form-control"
                        options={signedList}
                        onChange={this.handlePurposeChange}
                        defaultValue={signedList[0]}
                      />
                  </div>
                </div>
                <div className="nk-tb-item">
                  <div className="nk-tb-col tb-col-md">
                    <button
                      onClick={() => this.viewPDFReport()}
                      type="button"
                      className="btn btn-lg btn-primary"
                    >
                      Print Report
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <PDFVisitsReportDocument
          title={this.state.docTitle}
          content={this.state.pdfContent}
          isVisible={this.state.pdfDocOpen}
          onClose={() => this.setState({ pdfDocOpen: false })}
          bigForm={false}
        />
      </MainLayout>
    );
  }
}